import { jsx as _jsx } from "react/jsx-runtime";
import { BottomSheetLinkButtonContainer } from './styles/bottom-sheet-link-button.styled';
export const BottomSheetLinkButton = ({ children, onClick, dataTest = 'bottom-sheet-link-button', }) => (_jsx(BottomSheetLinkButtonContainer, { tabIndex: 0, role: "button", onClick: onClick, onKeyPress: ({ key }) => {
        if (key === 'Enter')
            onClick();
    }, as: "span", dataTest: dataTest, children: children }));
